module.exports = __webpack_public_path__ + "img/DE03217.2314dae7.png";